(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
  root.DeliveryCutoff = api;
  if (typeof document !== 'undefined') {
    var configNode = document.getElementById('delivery-cutoff-config');
    if (configNode && configNode.textContent) {
      api.start(JSON.parse(configNode.textContent));
    }
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  var WEEKDAY_CUTOFF_HOUR = 13;
  var WEEKDAY_CUTOFF_MINUTE = 0;

  function to24Hour(hour12, period) {
    var hour = parseInt(hour12, 10);
    var isPm = String(period).toUpperCase() === 'PM';
    if (isPm && hour !== 12) hour += 12;
    if (!isPm && hour === 12) hour = 0;
    return hour;
  }

  function createPlanner(config) {
    var bankHolidays = config.bankHolidays || [];
    var saturdayCutoffHour = to24Hour(config.saturdayCutoffHour12, config.saturdayCutoffPeriod);
    var saturdayCutoffMinute = parseInt(config.saturdayCutoffMinute, 10);

    function formatISODate(date) {
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      return date.getFullYear() + '-' + month + '-' + day;
    }

    function isBankHoliday(date) {
      return bankHolidays.indexOf(formatISODate(date)) !== -1;
    }

    function formatDate(date) {
      return date.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' });
    }

    function atTime(date, hour, minute) {
      var value = new Date(date);
      value.setHours(hour, minute, 0, 0);
      return value;
    }

    function isNonWorkingDay(date) {
      var day = date.getDay();
      return day === 0 || day === 6 || isBankHoliday(date);
    }

    function nextWorkingDay(date) {
      var next = new Date(date);
      do {
        next.setDate(next.getDate() + 1);
      } while (isNonWorkingDay(next));
      return next;
    }

    function nextDispatchDay(date) {
      var next = new Date(date);
      do {
        next.setDate(next.getDate() + 1);
      } while (next.getDay() === 0 || next.getDay() === 6 || isBankHoliday(next));
      return next;
    }

    function dayAfterShip(shipDate) {
      var delivery = new Date(shipDate);
      do {
        delivery.setDate(delivery.getDate() + 1);
      } while (delivery.getDay() === 0 || isBankHoliday(delivery));
      return delivery;
    }

    function deliveryAfterMissedWeekendCutoff(now) {
      var dispatchDay = nextWorkingDay(now);
      var collectionMinutes = saturdayCutoffHour * 60 + saturdayCutoffMinute;
      var weekdayCutoffMinutes = WEEKDAY_CUTOFF_HOUR * 60 + WEEKDAY_CUTOFF_MINUTE;
      if (collectionMinutes >= weekdayCutoffMinutes) {
        dispatchDay = nextWorkingDay(dispatchDay);
      }
      return nextWorkingDay(dispatchDay);
    }

    function describe(now, suffixText) {
      var day = now.getDay();
      var cutoffTime;
      var deliveryDate;
      var isBeforeCutoff;

      if (day === 6 || day === 0) {
        cutoffTime = atTime(now, saturdayCutoffHour, saturdayCutoffMinute);
        isBeforeCutoff = now < cutoffTime;
        deliveryDate = isBeforeCutoff ? nextWorkingDay(now) : deliveryAfterMissedWeekendCutoff(now);
      } else {
        cutoffTime = atTime(now, WEEKDAY_CUTOFF_HOUR, WEEKDAY_CUTOFF_MINUTE);
        isBeforeCutoff = now < cutoffTime && !isBankHoliday(now);
        deliveryDate = dayAfterShip(isBeforeCutoff ? now : nextDispatchDay(now));
      }

      var countdown;
      if (isBeforeCutoff) {
        var timeDiff = cutoffTime - now;
        var hours = Math.floor(timeDiff / (1000 * 60 * 60));
        var minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
        countdown = 'Order within ' + hours + 'h ' + minutes + 'm.';
      } else {
        countdown = 'Next day delivery available from tomorrow.';
      }

      var message = 'In stock. Get it on ' + formatDate(deliveryDate) + ' with Next Day Delivery. ' + countdown;
      if (suffixText) message += ' ' + suffixText;
      return message;
    }

    return { describe: describe };
  }

  function start(config) {
    var message = document.getElementById(config.elementId || 'delivery-message');
    if (!message) return;

    function render(holidays) {
      var planner = createPlanner({
        bankHolidays: holidays,
        saturdayCutoffHour12: config.saturdayCutoffHour12,
        saturdayCutoffMinute: config.saturdayCutoffMinute,
        saturdayCutoffPeriod: config.saturdayCutoffPeriod
      });
      message.innerText = planner.describe(new Date(), config.suffixText || '');
    }

    function init() {
      return fetch('https://www.gov.uk/bank-holidays.json')
        .then(function (response) { return response.json(); })
        .then(function (data) {
          var holidays = data['england-and-wales'].events.map(function (event) { return event.date; });
          render(holidays);
          setInterval(function () { render(holidays); }, 60000);
        });
    }

    return init();
  }

  return {
    to24Hour: to24Hour,
    createPlanner: createPlanner,
    start: start
  };
});
